import type { ConsignmentStatusCode, ConsignmentSummary } from '@/entities/consignments';
import { FilterSelect } from '@/shared/ui';

import { useConsignmentStatusChange } from '../model';
import { ConsignmentStatusDialog } from './consignment-status-dialog';

interface ConsignmentStatusSelectProps {
  consignmentId?: string;
  consignment?: Pick<ConsignmentSummary, 'statusCode' | 'allowedActions' | 'resetTargetStatusCode'>;
}

export function ConsignmentStatusSelect({ consignmentId, consignment }: ConsignmentStatusSelectProps) {
  const {
    currentStatusCode,
    statusOptions,
    isDisabled,
    target,
    isDialogOpen,
    setIsDialogOpen,
    isSubmitting,
    selectStatus,
    confirm
  } = useConsignmentStatusChange({ consignmentId, consignment });

  return (
    <>
      <FilterSelect<ConsignmentStatusCode>
        value={currentStatusCode}
        onChange={selectStatus}
        options={statusOptions}
        width="full"
        disabled={isDisabled}
      />

      {target && (
        <ConsignmentStatusDialog
          open={isDialogOpen}
          onOpenChange={setIsDialogOpen}
          target={target}
          isSubmitting={isSubmitting}
          onConfirm={confirm}
        />
      )}
    </>
  );
}
